import { render, staticRenderFns } from "./pricelist.vue?vue&type=template&id=3f0992b0&"
import script from "./pricelist.vue?vue&type=script&lang=js&"
export * from "./pricelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f0992b0')) {
      api.createRecord('3f0992b0', component.options)
    } else {
      api.reload('3f0992b0', component.options)
    }
    module.hot.accept("./pricelist.vue?vue&type=template&id=3f0992b0&", function () {
      api.rerender('3f0992b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ASY7YVnoZQBa/JS/comp/pricelist.vue"
export default component.exports